import React from 'react';
import './App.scss';
import Form from "./layouts/Form/Form";
import PopupResult from "./components/Popups/popupResult/PopupResult";
import API from "./Helpers/API";
import PopupError from "./components/Popups/popupError/popupError";
import axios from "axios";

class App extends React.Component {

  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.thanksPopupRef = React.createRef();
    this.errorPopupRef = React.createRef();
    this.formErrorPopupRef = React.createRef();
    this.isBusy = false;

    this.state = {
      secret: "fa130bc96848ea3534103deabe469174",
      infoTitle: "",
      infoText: "",
      errorMessage: "Пожалуйста, заполните поля",
      data: null,
      name: null,
      price: null,
    };
  }

  componentDidMount() {
    this.getXML();
    this.validBot = document.querySelector("#valid-bot");
  }

  onSubmit = () => {
    let { errorMessage, secret } = this.state;

    const data = this.formRef.current.collectData();

    if (!data || this.isBusy || this.validBot.value.length) {
      setTimeout(() => {
        if (!this.isBusy) {
          this.onError(errorMessage);
        }
      }, 10);
      return false;
    }

    this.isBusy = true;

    data["secret"] = secret;

    this.setState({ data }, this.onResolved);
  };

  successSubmit = () => {
    const { data, id, price } = this.state;
    const { email, name, phone } = data;

    let source = "lgcom_pricedrop";

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: source
      });

      window["rrApiOnReady"] = window["rrApiOnReady"] || [];
      window["rrApiOnReady"].push(() => window.rrApi.setEmail(email, { source, name, phone }));

      if (id && price) {
        window.rrApi.subscribeOnPriceDrop(email, [{ id, price }])
      }

    } catch (e) {
      console.warn(e.message);
    }

    this.setState({ data: null }, () => {
      this.thanksPopupRef.current.open();
      this.formRef.current.clearData();
      this.isBusy = false;
    });
  }

  errorSubmit = () => {
    this.setState({ data: null }, () => {
      this.errorPopupRef.current.open();
      this.isBusy = false;
    });
  };

  onError = errorMessage => {
    this.setState({ errorMessage });
    this.formErrorPopupRef.current.open();
  };

  onResolved = () => {
    const { data } = this.state;
    this.successSubmit();
    // API("/api/v1/requests", data, this.successSubmit, this.errorSubmit);
  };

  getXML() {
    axios.get("https://www.lg.com/ru/discount/discount.xml", {})
      .then(response => {
        let { data } = response;
        this.parseXML(data);
      })
      .catch(error => {
        console.warn(error.message);
      })
  }

  parseXML(xml) {
    const parser = new DOMParser();
    xml = parser.parseFromString(xml, "text/xml");
    let ids = xml.querySelectorAll("id");

    let url = new URL(window.location);
    let urlID = url.searchParams.get("id") || localStorage.getItem("id");
    let urlName = url.searchParams.get("model") || localStorage.getItem("model");

    if(urlID) {
      localStorage.setItem("id", urlID);
    }

    if(urlName) {
      localStorage.setItem("model", urlName);
    }

    let findIndex = Array.from(ids).findIndex(id => id.innerHTML === urlID);

    let name = xml.querySelectorAll("name")?.[findIndex]?.innerHTML || urlName || "Продукт не&nbsp;найден. Заполните форму, чтобы получать новости об&nbsp;акциях и&nbsp;скидках";
    let price = xml.querySelectorAll("price")?.[findIndex]?.innerHTML;

    this.setState({ id: urlID, name, price });
  }

  render() {
    const socials = ["mailru", "vkontakte", "yandex", "odnoklassniki"];
    // const socials = ["mailru", "vkontakte", "yandex", "facebook", "odnoklassniki"];
    const { name } = this.state;

    return (
      <div className={"pp-page-gift-wall"}>
        <PopupResult ref={this.thanksPopupRef}
                     title={"Ваша заявка отправлена"}
                     subtitle={"В ближайшее время вы получите письмо со скидкой"} />
        <PopupResult ref={this.errorPopupRef}
                     title={"Не удалось отправить заявку"} />
        <PopupError ref={this.formErrorPopupRef}
                    message={this.state.errorMessage} />

        <Form name={name}
              socials={socials}
              onError={this.onError}
              onSubmit={this.onSubmit}
              ref={this.formRef} />

      </div>
    );

  }

}

export default App;
